import React from 'react'
import PropTypes from 'prop-types'
import { Rectangle } from '../../../../helpers/math'
import { ZoneContainer } from './CollaborativeIndexation/Zone'
import { SelectionContainer } from './CollaborativeIndexation/Selection'

export function CollaborativeIndexation(props)
{
    return (
        <React.Fragment>
            { props.areCollaborativeIndexationsDisplayed && props.zones.map(zone => <ZoneContainer key={zone.uuid} zone={zone} {...props} />) }
            {
                props.selection && <ZoneContainer key={'pendingZone'} zone={{rect: props.selection}} selected={true} {...props} />
            }
            {
                props.isSelectionToolActive && <SelectionContainer {...props} />
            }
        </React.Fragment>
    )
}

CollaborativeIndexation.propTypes = {
    zones: PropTypes.array.isRequired,
    createdZone: PropTypes.instanceOf(Rectangle),
    areCollaborativeIndexationsDisplayed: PropTypes.bool.isRequired,
    isSelectionToolActive: PropTypes.bool.isRequired,
}
